import { useLayoutEffect, useRef } from 'react'
import { createPortal } from 'react-dom'

interface TutorialHeaderProps {
  onClose: () => void
  isCompletion?: boolean
}

const HEADER_OFFSET_VAR = '--hs-tutorial-header-offset'

export function TutorialHeader({ onClose, isCompletion = false }: TutorialHeaderProps) {
  const headerRef = useRef<HTMLDivElement>(null)

  useLayoutEffect(() => {
    document.body.classList.add('tutorial-header-active')
    const el = headerRef.current

    const syncOffset = () => {
      if (!el) {
        return
      }
      const height = Math.ceil(el.getBoundingClientRect().height)
      document.documentElement.style.setProperty(HEADER_OFFSET_VAR, `${height}px`)
    }

    syncOffset()
    const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(syncOffset) : null
    if (el && observer) {
      observer.observe(el)
    }
    window.addEventListener('resize', syncOffset)

    return () => {
      document.body.classList.remove('tutorial-header-active')
      document.documentElement.style.removeProperty(HEADER_OFFSET_VAR)
      observer?.disconnect()
      window.removeEventListener('resize', syncOffset)
    }
  }, [])

  return createPortal(
    <div
      ref={headerRef}
      data-tutorial-header="true"
      className={isCompletion ? 'tutorial-header--completion' : ''}
    >
      <h1>
        Onboarding tutorial
      </h1>
      <button
        type="button"
        onClick={onClose}
      >
        ×
      </button>
    </div>,
    document.body,
  )
}
